import requestApi from "@/utils/requestApi";
import NListGenerato from "@nxin/nxin-ui-pc/NListGenerato/NListGenerato.vue";

export default {
  components: {
    nListGenerato: NListGenerato,
  },

  data() {
    return {
      form: {
        payCheckStatus: "",
      },
      theadData: [
        {
          prop: "payCheckMonth",
          label: "对账日期",
        },
        {
          prop: "supplierShopName",
          label: "客户单位",
        },
        {
          prop: "payCheckStatusCn",
          label: "状态",
        },
        {
          prop: "purchaseOperateName",
          label: "操作人",
        },
        {
          prop: "purchaseOperateTime",
          label: "操作时间",
        },
        {
          prop: "fn",
          label: "操作",
          type: "custom",
        },
      ],
      tbodyData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchData: [
        {
          tag: "select",
          prop: "payCheckStatus",
          value: "",
          label: "状态",
          options: [
            {
              value: "0",
              label: "待确认",
            },
            {
              value: "1",
              label: "已对账",
            },
          ],
          placeholder: "请选择",
        },
      ],
      buttonFunctionData: [
        {
          tag: "button",
          icon: "el-icon-download",
          prop: "export",
          type: "primary",
          label: "导出",
        },
      ],
    };
  },

  created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/mj/selPage`, {
        ...this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      loading.close();

      if (code == "0") {
        this.total = Number(data.total);
        this.tbodyData = data.list;
      } else {
        this.$message.error(msg);
      }
    },

    sizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadData();
    },
    currentChange(current) {
      if (Number.isNaN(Number(current))) {
        return;
      }
      this.pageNum = current;
      this.loadData();
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    searchSubmit(form) {
      this.form = form;
      this.loadData();
    },

    async handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/mj/export`, this.form);
      loading.close();

      if (code == "0") {
        this.$open(data.url, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },

    viewPdf(slotProps) {
      this.$open(slotProps.row.contractUrl);
    },

    toConfirm(slotProps) {
      this.$router.push(`/supplier/generateBill?busId=${slotProps.row.id}`);
    },
  },
};
